import type { TFunction } from "i18next";

/** The name a removed account is stored under. The SPA never shows it as
 *  is: it renders the translated ``common.deleted_user`` instead. */
export const DELETED_USER_NAME = "Deleted user";

/** How to name a user in the UI: "Deleted user" (translated) for a
 *  removed account, else the display name, else the email. */
export function userLabel(
  t: TFunction,
  user: { display_name?: string | null; email?: string | null; deleted?: boolean },
): string {
  if (user.deleted) return t("common.deleted_user");
  return user.display_name || user.email || "";
}

/** A stored contributor name, with a removed account's localised. */
export function contributorLabel(t: TFunction, name: string): string {
  return name === DELETED_USER_NAME ? t("common.deleted_user") : name;
}

type Participant = { id: string; display_name?: string | null; email?: string | null; deleted?: boolean };

/** ``{user_id: label}`` for a session's owner and collaborators: what the
 *  chat shows as the author of each person's messages. A removed account
 *  shows as "Deleted user" (Privacy Policy 10.2). */
export function participantLabels(
  t: TFunction,
  owner: Participant | null | undefined,
  collaborators: Participant[] | null | undefined,
): Record<string, string> {
  const map: Record<string, string> = {};
  if (owner) map[owner.id] = userLabel(t, owner);
  for (const c of collaborators ?? []) map[c.id] = userLabel(t, c);
  return map;
}
